export default __webpack_public_path__ + "static/media/xs-logo.80b25170.png";